import React from "react";
import useReveal from "../../hooks/useReveal";
import { waUrl } from "../../config/bdk";

const items = [
  {
    key: "img",
    title: "Imágenes publicitarias",
    desc: "Para promociones, mensualidades, inscripciones, retos y campañas.",
    prices: [
      { label: "Imagen individual", price: "$220" },
      { label: "Pack de 5", price: "$990" },
      { label: "Pack de 10", price: "$1,890" },
    ],
    delivery: "5 días hábiles",
    cta:
      "Hola, quiero información sobre imágenes publicitarias por separado (BDKSISTEMAS).",
    ctaLabel: "Quiero imágenes",
  },
  {
    key: "vid",
    title: "Video publicitario con IA",
    desc: "Video corto para reels, historias, estados de WhatsApp o anuncios.",
    prices: [{ label: "1 video", price: "$1,249" }],
    delivery: "3 días hábiles por video",
    cta:
      "Hola, quiero información sobre videos publicitarios con IA (BDKSISTEMAS).",
    ctaLabel: "Quiero un video",
  },
  {
    key: "ia",
    title: "Imágenes tipo fotografía con IA",
    desc: "Visuales realistas para representar servicios, productos o escenas.",
    prices: [
      { label: "Imagen individual", price: "$150" },
      { label: "Pack de 5", price: "$690" },
      { label: "Pack de 10", price: "$1,290" },
    ],
    delivery: "4 días hábiles",
    note:
      "No sustituye una sesión fotográfica real cuando se requiere exactitud total.",
    cta:
      "Hola, quiero información sobre imágenes tipo fotografía con IA (BDKSISTEMAS).",
    ctaLabel: "Quiero imágenes IA",
  },
];

const IndividualServices = () => {
  useReveal();
  return (
    <section
      id="individuales"
      data-testid="section-individuales"
      className="bdk-section"
      style={{ background: "var(--paper)" }}
    >
      <div className="container-bdk">
        <div className="max-w-[760px] mx-auto text-center mb-14 bdk-reveal bdk-reveal--up">
          <p className="kicker">Servicios individuales</p>
          <h2 className="font-display text-[38px] sm:text-[48px] md:text-[56px] lg:text-[64px]">
            También puedes contratar
            <br />
            servicios por separado.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((it, i) => (
            <article
              key={it.key}
              data-testid={`individual-card-${it.key}`}
              className="p-7 rounded-[14px] bg-white flex flex-col bdk-reveal bdk-reveal--up"
              style={{
                border: "1px solid var(--line)",
                borderBottom: "4px solid var(--red)",
                "--reveal-delay": `${i * 90}ms`,
              }}
            >
              <h3 className="font-display text-[25px] leading-none">
                {it.title}
              </h3>
              <p className="mt-3 text-[#666873] text-[13px]">{it.desc}</p>

              <ul className="grid gap-1.5 my-5 list-none text-[#666873] text-[13px] flex-1">
                {it.prices.map((p, j) => (
                  <li
                    key={j}
                    className="flex justify-between pb-1.5"
                    style={{ borderBottom: "1px solid var(--line)" }}
                  >
                    <span>{p.label}</span>
                    <strong style={{ color: "var(--red)" }}>{p.price}</strong>
                  </li>
                ))}
              </ul>

              <p
                className="inline-block self-start mb-4 px-2.5 py-1 rounded-full text-[10px] font-black uppercase tracking-wider"
                style={{ background: "#f0f0f3", color: "var(--ink)" }}
              >
                {it.delivery}
              </p>

              {it.note && (
                <p className="text-[10px] text-[#999aa2] mb-4">{it.note}</p>
              )}

              <a
                href={waUrl(it.cta)}
                target="_blank"
                rel="noreferrer"
                data-testid={`individual-cta-${it.key}`}
                className="bdk-btn"
                style={{
                  background: "#3a3a44",
                  color: "#fff",
                  border: "1px solid #3a3a44",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "#101018";
                  e.currentTarget.style.borderColor = "#101018";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "#3a3a44";
                  e.currentTarget.style.borderColor = "#3a3a44";
                }}
              >
                {it.ctaLabel}
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndividualServices;
